import { render, staticRenderFns } from "./MSOGroups.vue?vue&type=template&id=54206d0f&"
import script from "./MSOGroups.vue?vue&type=script&lang=js&"
export * from "./MSOGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports